import i18n from 'i18n-js';
import * as Yup from 'yup';

const zip_by_country = (
  USAInputValue = 'USA',
  CanadaInputValue = 'CAN',
  MexicoInputValue = 'MEX',
  AustraliaInputValue = 'AUS',
  NewZealandInputValue = 'NZL'
) =>
  Yup.string()
    .when('country', {
      is: USAInputValue,
      then: Yup.string().matches(
        /^[0-9]{5}$/,
        `${i18n.t('customers.invalid_zip')} the United States`
      ),
    })
    .when('country', {
      is: CanadaInputValue,
      then: Yup.string().matches(
        /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
        `${i18n.t('customers.invalid_zip')} Canada`
      ),
    })
    .when('country', {
      is: MexicoInputValue,
      then: Yup.string().matches(/^[0-9]{5}$/, `${i18n.t('customers.invalid_zip')} Mexico`),
    })
    .when('country', {
      is: AustraliaInputValue,
      then: Yup.string().matches(/^[0-9]{4}$/, `${i18n.t('customers.invalid_zip')} Australia`),
    })
    .when('country', {
      is: NewZealandInputValue,
      then: Yup.string().matches(/^[0-9]{4}$/, `${i18n.t('customers.invalid_zip_nz')}`),
    })
    .when('country', {
      is: (val) => !val,
      then: Yup.string().length(0, i18n.t('customers.select_country_first')),
    });

export { zip_by_country };
